import { KiteIcon } from '@kite/react-kite';
import React from 'react';
import './AccordionRow.scss';

export interface AccordionRowInputs {
    visibleText: string;
    hiddenText: string;
    expanded: boolean;
    clickHandler: () => void;
    id: string;
}

export const AccordionRow = ({
    id,
    visibleText,
    hiddenText,
    expanded,
    clickHandler,
}: AccordionRowInputs) => {
    const sectId = `sect-${id}`;
    const headId = `head-${id}`;
    const typestack = `typestack-body-2`;

    return (
        <li>
            <h3 className="paragraph__accordion_header">
                <button
                    aria-expanded={expanded}
                    aria-controls={sectId}
                    id={headId}
                    className={`${typestack} ${expanded ? `bold` : ``}`}
                    onClick={clickHandler}
                >
                    {visibleText}
                    <KiteIcon
                        icon={expanded ? `ki-chevron-up` : `ki-chevron-down`}
                    />
                </button>
            </h3>
            <div
                id={sectId}
                role="region"
                aria-labelledby={headId}
                className={`paragraph__accordion_text ${typestack} ${
                    expanded ? `visible` : ``
                }`}
                dangerouslySetInnerHTML={{ __html: hiddenText }}
            ></div>
        </li>
    );
};
